import { Form, Input } from 'antd'

import { FormWrapper } from 'components'
import { KEYS } from '__constants__'
import PropTypes from 'prop-types'
import { useTranslations } from 'hooks'

const ContactUsSimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group } = props

  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting new form instance from Form.useForm hook */
  const [baseForm] = Form.useForm()

  /* Getting used form from props or using base form */
  const usedForm = form || baseForm

  /* Resetting form on cancel */
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }
  /* Submitting form on enter key press */
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }

  /* Generating form field names */
  const getFieldName = (subGroup) => (group ? [...group, subGroup] : [subGroup])

  return (
    <FormWrapper
      title={t('Contact us')}
      onFinish={onSubmit}
      initialValues={initialValues}
      onKeyPress={handleKeyPress}
      onReset={handleCancel}
      showTitle={showTitle}
      form={usedForm}
      group={group}
      formActions={null}>
      <Form.Item
        data-area="contact-us"
        name={getFieldName('subject')}
        label={t('Subject')}
        rules={[
          {
            required: true,
            message: t('Please enter subject ')
          }
        ]}>
        <Input placeholder={t('Please enter subject here.')} size="default" />
      </Form.Item>
      <Form.Item
        data-area="contact-us"
        name={getFieldName('message')}
        label={t('Message')}
        rules={[
          {
            required: true,
            message: t('Please enter your message')
          }
        ]}>
        <Input.TextArea
          rows={6}
          placeholder={t(
            'Please enter your message here. Our team will get back to you as soon as possible.'
          )}
        />
      </Form.Item>
    </FormWrapper>
  )
}

ContactUsSimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array,
  children: PropTypes.node
}

export default ContactUsSimpleForm
